<div class="accueil-container">
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header [card]="false" [titlePath]="['Dématérialisation de procédures simplifiée']"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content class="mat-elevation-z4" fxLayoutGap="10px" style="padding: 10px 10px 10px 10px;" *ngIf="environment.env==='test'">
      <div  style="padding-bottom: 10px;">
        <mat-icon aria-hidden="true" color="primary" data-cy="icon-accueil-warning">warning</mat-icon>
        <strong>
          <mark>
            Cet espace est l'application de TEST afin de prendre en main l'outil ou de détecter des anomalies,
            aucune donnée / information ne sera conservée et ne représente en aucun cas de réelles informations à exploiter
          </mark>
        </strong>
        <mat-icon aria-hidden="true" color="primary" data-cy="icon-accueil-warning-2">warning</mat-icon>
      </div>
    </mat-card-content>
    <mat-card-content class="mat-elevation-z4" fxLayoutGap="10px" style="padding: 10px">
        <p style="padding: 10px;margin-left: 10px;">
          Cette application vous permet d'effectuer une demande à partir d'un lien que vous avez reçu ou ayant été déposé sur un portail
        </p>
    </mat-card-content>
  </mat-card>
</div>
